import { useMediaQuery } from 'react-responsive';
import theme from '../../../../assets/stylesheets/_settings.global.scss';

export default function useCommonProps() {
  const mediaQueries = {
    isXXLarge: useMediaQuery({ query: `(min-width: ${theme.breakpointXxlargeMin})` }),
    isXLarge: useMediaQuery({ query: `(min-width: ${theme.breakpointXlargeMin})` }),
    isLarge: useMediaQuery({ query: `(min-width: ${theme.breakpointLargeMin})` }),
    isFeaturedLarge: useMediaQuery({ query: '(min-width: 1024px)' }),
    isMobile: useMediaQuery({ query: `(max-width: ${theme.breakpointSmallMax})` }),
    isFeaturedMedium: useMediaQuery({ query: '(min-width: 768px)' }),
    isMobileOrTablet: useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` }),
  };

  return {
    ...theme,
    ...mediaQueries,
  };
}
